export default {
    defaultTemplate: undefined,
    templates: [],
    sendMessagesPayload: {
        to: "",
        template: ""
    },
    responseApi: null
};



// WEBPACK FOOTER //
// ./src/modules/whatsapp-api/state.js